export const UserType = {
    Administrator: 0,
    Supervisor: 1,
    Operator: 2,
    Distributor: 3
}